.contactSection {
  padding-inline: 2rem;
}

.heading {
  margin-block: 20px;
  color: var(--secondary-color);
}

.cardsContainer {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  font-family: "Nunito Variable", sans-serif;
  color: var(--secondary-color);
}

.link {
  padding: 70px;
  text-align: center;
}

.contactSection svg {
  width: 100px;
  height: auto;
}

/* Tablet */
@media (min-width: 768px) {
  .heading {
    padding-bottom: 17px;
  }
  .link h3 {
    padding-top: 15px;
  }
}

/* Desktop */
@media (min-width: 1024px) {
  .contactSection {
    padding: 3rem 5rem;
  }
}

/* Enable hover only on non-touch devices */
@media (hover: hover) and (pointer: fine) {
  .EmailIcon:hover {
    color: #ff7f50;
  }
  .GitHubIcon:hover {
    color: hsla(0, 0%, 100%, 0.8);
  }
  .XTwitterIcon:hover {
    color: #1a8cd8;
  }
  .LinktreeIcon:hover {
    color: #43e55e;
  }
  /* .InstagramIcon svg:hover {
    fill: #d6249f;
    fill: url("#instagram-icon-gradient");
  } */
}
